import { StatusBar } from "expo-status-bar";
import React from "react";
import { StyleSheet, Text, View, ScrollView } from "react-native";

export default function App() {
  return (
    <ScrollView contentContainerStyle={styles.container}>
      <h2>
        <strong>Privacy Policy</strong>
      </h2>

      <p>Welcome to Aventurile Ratoiului Adalbert!</p>

      <p>These terms and conditions outline the rules and regulations for the use of Alina Manole's Website, located at https://www.alinamanole.ro.</p>

      <p>
        We're glad you want to download and listen our children's book. We value the privacy of all of our users and we know you care about your privacy and the privacy of your children, so we created this Privacy Policy. It explains the information
        we collect from users and how and when we disclose or use it. By accessing or using this application, you are consenting to this Privacy Policy. When you use our application, you also agree to our Terms of Service.
      </p>
      <h3>
        <strong>INFORMATION WE COLLECT</strong>
      </h3>

      <p>WWe do not collect informations such as: - your year of birth, email address, password, your child’s age and a name for your child’s profile - your payment information, mailing address, and telephone number.</p>

      <p>
        We and our service providers may collect information from you as you use our Services, including: Information that you provide in public forums or otherwise voluntarily submit through our product features.
        <br />
        Through your browser or device: Certain information is collected by most browsers or automatically through your device, such as your Media Access Control (MAC) address, computer type (Windows or Macintosh), screen resolution, operating system
        name and version, device manufacturer and model, language, Internet browser type and version and the name and version of the Services you are using. We use this information to help ensure that the Services function properly.
      </p>

      <h3>
        <strong>HOW WE USE INFORMATION</strong>
      </h3>

      <p>
        We use these types of information in the following ways: 1) To provide you with the ”Aventurile rățoiului Adalbert” ; 2) To communicate with you about your purchase; 3) To investigate and prevent activities that may violate our policies or be
        illegal.
      </p>

      <h3>
        <strong>HOW WE SHARE INFORMATION</strong>
      </h3>

      <p>Your information may be disclosed:</p>

      <p>To our affiliates for the purposes described in this Privacy Policy.</p>

      <p>
        To our service providers who provide services such as website hosting, data analysis, payment processing, order fulfillment, information technology and related infrastructure provision, customer service, email delivery, auditing, and other
        services.
      </p>

      <p>To a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer or other disposition of all or any portion of our business, assets or stock (including in bankruptcy or similar proceedings).</p>

      <p>
        As we believe to be necessary or appropriate: (a) under applicable law, including laws outside your country of residence; (b) to comply with legal process; (c) to respond to requests from public and government authorities, including public
        and government authorities outside your country of residence; (d) to enforce our terms and conditions; (e) to protect our operations or those of any of our affiliates; (f) to protect our rights, privacy, safety or property, and/or that of our
        affiliates, you or others; and (g) to allow us to pursue available remedies or limit the damages that we may sustain.
      </p>
      <p>
        We may use and disclose information that does not identify or otherwise directly relate to an individual for any purpose, except where we are required to do otherwise under applicable law. For example, we may share aggregated information
        publicly to demonstrate growth trends related to the usage of the ”Aventurile rățoiului Adalbert” in certain areas.
      </p>

      <h3>
        <strong>TRANSPARENCY AND CONTROLS</strong>
      </h3>

      <p>
        We understand and respect your privacy concerns at ”Aventurile rățoiului Adalbert”. Accordingly, we provide you with the ability to make certain choices related to our audiobook application, use, and sharing of your information. These choices
        may include:
      </p>
      <p>You may request access to the personal information that we have collected on your account and ask us to change or delete it</p>

      <h3>
        <strong>CHILDREN’S PRIVACY</strong>
      </h3>
      <p>
        We do not collect personal information from children under the age of 13. Any child under the age of 13 using the ”Aventurile rățoiului Adalbert” must do so with permission from a parent. All full names, email addresses, and credit card
        billing information must be from a parent or guardian. We encourage parents to take an active role in their children's activities and interests on their devices. When buying ”Aventurile rățoiului Adalbert”, we may ask a series of general
        questions including your child's age, interests and gender. This information is used to customize content to your child's age and interests. We do not use or disclose this information for any other purposes except to provide you with quality
        service. Any data that is shared is done so on an anonymous, aggregate basis among all users or is related to communicating reading behavior patterns to publishers.
      </p>

      <h3>
        <strong>THIRD PARTY SERVICES</strong>
      </h3>

      <p>
        This Privacy Policy does not address, and we are not responsible for, the privacy, information or other practices of any third parties, including any third party operating any site or service to which the Services link. The inclusion of a
        link on the Services does not imply endorsement of the linked site or service by us or by our affiliates. Although the ”Aventurile rățoiului Adalbert” is a safe place for kids, a child may leave the ”Aventurile rățoiului Adalbert” service
        using the iOS or Android device Home button. Should your child leave the ”Aventurile rățoiului Adalbert” service for another application or browser, this Privacy Policy no longer applies. We have no control over how other applications or
        sites collect, distribute or otherwise use your personal information or how they safeguard and secure your personal information.
      </p>

      <h3>
        <strong>SECURITY</strong>
      </h3>

      <p>
        In circumstances where your personal information is collected, we use reasonable procedural and digital security measures that are designed to help protect against loss, unauthorized access, disclosure, alteration or destruction of
        information and data, such as password protection and secure socket layer. Unfortunately, no data transmission or storage system can be guaranteed to be 100% secure. If you have reason to believe the security of your account has been
        compromised, please immediately notify us in accordance with the “Contact Us” section below
      </p>

      <h3>
        <strong>CHANGES TO THIS PRIVACY POLICY</strong>
      </h3>

      <p>
        We reserve the right to change or modify our Privacy Policy from time to time by posting a revised Privacy Policy on our site. The “last updated” legend at the top of this page indicates when this Policy was last revised. As an user of the
        ”Aventurile rățoiului Adalbert” service, you will be subject to the terms of the then-current Privacy Policy. We ask that you refer to the Privacy Policy on a continuing basis so that you understand our current privacy practices.
      </p>

      <h3>
        <strong>CONTACT US</strong>
      </h3>

      <p>
        If you would like to opt out of marketing communications from Adalbert you can do so by emailing: alinatmanole@gmail.com or by following the unsubscribe link in each such communication. If you would like to contact us with questions or
        feedback, please contact us here
        <br />
        ”Aventurile rățoiului Adalbert” is owned and operated by Alina Manole, Finlanda St, 17, Bucharest.
      </p>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    alignSelf: "center",
    marginVertical: 30,
    maxWidth: 700,
    // justifyContent: "center",
  },
});
